import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = [];

  private readonly _router = inject(Router);

  initialize(): void {
    this._router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        pairwise()
      )
      .subscribe(([prev, curr]) => {
        this.history.push(prev.urlAfterRedirects);
      });
  }

  getPreviousUrl(): string | null {
    return this.history.length > 0
      ? this.history[this.history.length - 1]
      : null;
  }
}
